import { createEntityAdapter } from '@ngrx/entity';
import { sortByCustomerConnectedTimeAsc } from '../../common/helpers/conversion-comparers.helper';
import { EmailConversation } from '../models/email-conversation.model';

export const emailConversationEntityAdapter = createEntityAdapter<EmailConversation>({
  selectId: conversation => conversation.id,
  sortComparer: sortByCustomerConnectedTimeAsc
});
